import { render, staticRenderFns } from "./researchProject.vue?vue&type=template&id=2506bf0b&scoped=true&"
import script from "./researchProject.vue?vue&type=script&lang=js&"
export * from "./researchProject.vue?vue&type=script&lang=js&"
import style0 from "./researchProject.vue?vue&type=style&index=0&id=2506bf0b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506bf0b",
  null
  
)

export default component.exports